export const EMAILJS_SERVICE_ID = "service_apr9kue";
export const EMAILJS_TEMPLATE_ID = "template_n5g65yq";
export const EMAILJS_PUBLIC_API_KEY = "m4eaxErqEMB9yaWd1";
